<template>
  <div v-if="!isFetching">
    <header-section :prismic_data="prismic_data" :windowSize="windowSize" />
    <video-section :prismic_data="prismic_data" :windowSize="windowSize" />
    <share-section :prismic_data="prismic_data" :windowSize="windowSize" />
    <content-section :prismic_data="prismic_data" />
    <meme-generator :prismic_data="prismic_data" :windowSize="windowSize" />
    <footer-section :prismic_data="prismic_data" :openedPolicy="openedPolicy" />
    <a href id="scroll-top" v-scroll-to="'body'">
      <font-awesome-icon icon="angle-up" />
    </a>
  </div>
</template>

<script>
import HeaderSection from "../components/HeaderSection.vue";
import VideoSection from "../components/VideoSection.vue";
import ContentSection from "../components/ContentSection.vue";
import ShareSection from "../components/ShareSection.vue";
import MemeGenerator from "../components/MemeGenerator.vue";
import FooterSection from "../components/FooterSection.vue";

export default {
  name: "Landing",
  components: {
    HeaderSection,
    VideoSection,
    ShareSection,
    ContentSection,
    MemeGenerator,
    FooterSection,
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { vmid: "description", name: "description", content: this.description },
      ],
      htmlAttrs: {
        lang: this.locale,
      },
    };
  },
  data() {
    return {
      prismic_data: {},
      title: "",
      description: "",
      windowSize: window.innerWidth,
      isFetching: true,
      locale: this.$route.name === "index_en" ? "en" : "ua",
      openedPolicy: this.$route.hash === "#privacy-policy",
    };
  },
  created() {
    window.addEventListener("resize", this.resizeHandler);
    window.addEventListener("scroll", this.scrollHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler);
    window.removeEventListener("scroll", this.scrollHandler);
  },
  methods: {
    resizeHandler(e) {
      this.windowSize = e.target.innerWidth;
    },
    scrollHandler(e) {
      this.toggleVisibilityScrollToTop();
    },
    // toggle visibility of the scroll to top button
    toggleVisibilityScrollToTop() {
      if (
        document.body.scrollTop > 250 ||
        document.documentElement.scrollTop > 250
      ) {
        document.getElementById("scroll-top").className = "show";
      } else {
        document.getElementById(
          "scroll-top"
        ).className = document
          .getElementById("scroll-top")
          .className.replace("show", "");
      }
    },
  },
  mounted() {
    let lang = this.$route.name === "index_en" ? "en-gb" : "ua-ua";

    if (this.$route.hash === "#privacy-policy") {
      this.$router.push("#privacy-policy");
    }

    this.$prismic.client
      .query(this.$prismic.Predicates.at("document.type", "landing_page"), {
        lang: lang,
      })
      .then((response) => {
        // If there is no data, fallback to "ua" default translation
        if (response.results_size === 0) {
          this.$router.push("/");
          this.$router.go(0);
          return;
        }
        // Data from Prismic
        this.prismic_data = response.results[0].data;
        // SEO
        this.title = this.prismic_data.seo_title;
        this.description = this.prismic_data.seo_description;
        this.isFetching = false;
      });
  },
};
</script>

<style lang="scss" scoped>
#scroll-top {
  position: fixed;
  right: 15px;
  bottom: -40px;
  display: none;
  width: 40px;
  height: 40px;
  background: #212121;
  text-align: center;
  line-height: 40px;
  @include transition(0.25s);
  @media (max-width: $breakpoint-sm) {
    display: block;
  }
  &.show {
    bottom: 40px;
  }
  svg path {
    color: white;
  }
}
</style>